export default "__VITE_ASSET__B_KwG0fG__";